import PubSub from "pubsub-js";
import Slick from "slick-carousel";
import loadTouchEvents from 'jquery-touch-events';
import Plyr from 'plyr/dist/plyr.polyfilled.js';

var MediaGallery = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-MediaGallery',
	};

	$.extend(true, this.options, options);

};

MediaGallery.prototype.init = function() {

	var self = this;

	this.componentId = this.options.$el.data('componentId');
	this.$videoSlideTemplate = this.options.$el.find(`.${self.options.baseClass}__slideTemplate--video`);

	// sliders
	this.$slider = this.options.$el.find(`.${self.options.baseClass}__slider`);

	this.initSlider();

	// swipe events
	this.options.$el.on('swiperight', function() {
		// self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.on('swipeleft', function() {
		// self.restartAutoplay();
		self.nextSlide();
	});

	// previous/next buttons
	this.options.$el.find(`.${self.options.baseClass}__previousButton`).on('click', function() {
		// self.restartAutoplay();
		self.previousSlide();
	});
	this.options.$el.find(`.${self.options.baseClass}__nextButton`).on('click', function() {
		// self.restartAutoplay();
		self.nextSlide();
	});

	// start autoplay
	// this.sliderAutoplayInterval = window.setInterval(function() {
	// 	self.nextSlide();
	// }, 8000);

	PubSub.subscribe('MediaGallery:updateSlides', function(msg, data) {
		
		var componentId = data[0];
		var galleryItems = data[1];

		if (self.componentId == componentId) {
			self.updateSlides(galleryItems);
		}

	});

};

MediaGallery.prototype.initSlider = function() {

	var self = this;

	this.$slider.slick({
		arrows: false,
		fade: false,
		infinite: true,
		speed: 750,
		swipe: false,
	});

	self.initVideoSlides();

};

MediaGallery.prototype.updateSlides = function(newSlides) {

	var self = this;

	this.$slider.slick('unslick');

	this.$slider.empty();

	// hide the arrows if there is only one slide
	if (newSlides.length < 2) {
		self.options.$el.addClass(`${self.options.baseClass}--nextPrevHidden`);
	}
	else {
		self.options.$el.removeClass(`${self.options.baseClass}--nextPrevHidden`);
	}

	// add our slides
	if (newSlides.length < 1) {
		var newSlide = self.createMissingImageSlide();
		this.$slider.append(newSlide);
	}
	else {

		for (var i = 0; i < newSlides.length; i++) {
			
			var slide = newSlides[i];

			if (slide.type == 'image') {
				var newSlide = self.createImageSlide(slide);
			}
			else if (slide.type == 'youtube') {
				var newSlide = self.createYoutubeSlide(slide.videoId);
			}
			// console.log(newSlide);
			this.$slider.append(newSlide);

		}

	}

	this.initSlider();

};

MediaGallery.prototype.createMissingImageSlide = function() {

	var self = this;

	return `
		<div class="${self.options.baseClass}__slide ${self.options.baseClass}__slide--image ${self.options.baseClass}__slide--imageMissing"></div>
	`;

};

MediaGallery.prototype.createImageSlide = function(slide) {

	var self = this;

	// check if this image slide is set up to use srcset
	// if (slide.sources && slide.sizes) {
	// 	let element = `
	// 	<div class="${self.options.baseClass}__slide ${self.options.baseClass}__slide--image">
	// 		<img
	// 			src="${slide.url}"
	// 			srcset="${slide.sources}"
	// 			sizes="${slide.sizes}"
	// 		/>
	// 	</div>
	// 	`;
	// }
	// else {
		let element = `
		<div class="${self.options.baseClass}__slide ${self.options.baseClass}__slide--image">
			<img src="${slide.url}" />
		</div>
		`;
	// }
	

	return element;

};

MediaGallery.prototype.createYoutubeSlide = function(videoId) {

	var self = this;

	var $newVideoSlide = this.$videoSlideTemplate.clone();

	var videoUrl = `https://www.youtube.com/embed/${videoId}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;

	$newVideoSlide.find(`.${self.options.baseClass}__videoPlayer iframe`).prop('src', videoUrl);

	return $newVideoSlide.html();

};

// MediaGallery.prototype.restartAutoplay = function() {

// 	var self = this;

// 	clearInterval(self.sliderAutoplayInterval);

// 	self.sliderAutoplayInterval = window.setInterval(function() {
// 		self.nextSlide();
// 	}, 8000);

// };

MediaGallery.prototype.nextSlide = function() {
	this.$slider.slick('slickNext');
};

MediaGallery.prototype.previousSlide = function() {
	this.$slider.slick('slickPrev');
};

MediaGallery.prototype.initVideoSlides = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__slider .${self.options.baseClass}__slide--video`).each(function() {

		var $videoPlayer = $(this).find(`.${self.options.baseClass}__videoPlayer`);

		var player = new Plyr( $videoPlayer, {
			enabled: true,
			controls: ['progress'],
			settings: ['captions', 'quality', 'speed', 'loop'],
			autoplay: false,
			muted: false,
			clickToPlay: true,
			hideControls: false,
			resetOnEnd: false,
			ratio: '16:9', // The format is 'w:h' - e.g. '16:9' or '4:3'. HTML5 and Vimeo detect ratio automatically, youtube defaults to 16:9
		} );

		$(this).find(`.${self.options.baseClass}__playButton`).on('click', function() {

			if ($(this).hasClass(`${self.options.baseClass}__playButton--playing`))
			{
				player.pause();
			}
			else
			{
				player.play();
			}

		});

		player.on('playing', event => {

			const instance = event.detail.plyr;
			
			$(this).find(`.${self.options.baseClass}__playButton`).removeClass(`${self.options.baseClass}__playButton--paused`).addClass(`${self.options.baseClass}__playButton--playing`);
			$(this).find(`.${self.options.baseClass}__posterImage`).addClass(`${self.options.baseClass}__posterImage--hidden`)

			// clearInterval(self.sliderAutoplayInterval);

		});

		player.on('pause', event => {

			const instance = event.detail.plyr;
			
			$(this).find(`.${self.options.baseClass}__playButton`).removeClass(`${self.options.baseClass}__playButton--playing`).addClass(`${self.options.baseClass}__playButton--paused`);
			$(this).find(`.${self.options.baseClass}__posterImage`).removeClass(`${self.options.baseClass}__posterImage--hidden`)

			// self.restartAutoplay();

		});

		self.$slider.on('beforeChange', function() {
			player.pause();
		});

		// when poster image is clicked, play video
		$(this).find(`.${self.options.baseClass}__posterImage`).on('click', function() {
			player.play();
		});

		PubSub.subscribe('ModalUnitDetail:Closing', function() {
			player.pause();
		});

	});

};

export default MediaGallery;
